module.exports = __webpack_public_path__ + "img/logo.725115ee.png";